import React, { useEffect, useState } from "react";
import api from "../api";
import DashboardShell from "../components/DashboardShell";

function RiderOrdersPage() {
  const [orders, setOrders] = useState([]);
  const [message, setMessage] = useState("");
  const links = [
    { to: "/rider", label: "Overview" },
    { to: "/rider/orders", label: "Assigned Orders" },
  ];

  useEffect(() => {
    api.get("/orders")
      .then((res) => setOrders(res.data.filter((order) => order.status === "packed" || order.status === "ready" || order.status === "picked_up")))
      .catch((error) => console.error("Error fetching rider orders:", error.message));
  }, []);

  const updateStatus = async (id, status) => {
    try {
      const res = await api.put(`/orders/${id}/status`, { status });
      setOrders((prev) => prev.map((order) => (order._id === id ? res.data.order : order)));
      setMessage("Order status updated");
    } catch (error) {
      console.error("Error updating status:", error.message);
      setMessage("Error updating status");
    }
  };

  return (
    <DashboardShell title="Rider — Orders" subtitle="Pick up and deliver assigned orders." links={links}>
      <h1>Assigned Orders</h1>
      {message && <p>{message}</p>}
      {orders.map((order) => (
        <div key={order._id} style={{ border: "1px solid #eee", borderRadius: "8px", padding: "1rem", marginBottom: "1rem" }}>
          <p><strong>ID:</strong> {order._id}</p>
          <p><strong>Delivery address:</strong> {order.deliveryAddress}</p>
          <p><strong>Status:</strong> {order.status}</p>
          <ul>{order.items.map((item, index) => <li key={index}>{item.name} x {item.quantity}</li>)}</ul>
          <div style={{ marginTop: "0.5rem", display: "flex", gap: "0.5rem" }}>
            <button onClick={() => updateStatus(order._id, "picked_up")}>Mark picked up</button>
            <button onClick={() => updateStatus(order._id, "delivered")}>Mark delivered</button>
          </div>
        </div>
      ))}
    </DashboardShell>
  );
}

export default RiderOrdersPage;
